/**
 * Shared utility functions
 */
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge Tailwind classes safely */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/** Format number as USD currency */
export function formatCurrency(amount, opts = {}) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...opts,
  }).format(amount)
}

/** Format timestamp to readable string */
export function formatDateTime(value) {
  if (!value) return '—'

  // Handle format: yyyyMMdd_HHmmss
  if (/^\d{8}_\d{6}$/.test(value)) {
    const year = Number(value.substring(0, 4))
    const month = Number(value.substring(4, 6)) - 1
    const day = Number(value.substring(6, 8))

    const hour = Number(value.substring(9, 11))
    const minute = Number(value.substring(11, 13))
    const second = Number(value.substring(13, 15))

    const date = new Date(year, month, day, hour, minute, second)

    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(date)
  }

  const date = new Date(value)

  if (isNaN(date.getTime())) {
    return value
  }

  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)
}
// export function formatDateTime(value) {
//   if (!value) return '—'

//   const date = new Date(value)

//   // Handle invalid dates safely
//   if (isNaN(date.getTime())) {
//     return value
//   }

//   return new Intl.DateTimeFormat('en-US', {
//     dateStyle: 'medium',
//     timeStyle: 'short',
//   }).format(date)
// }

/** Format date only */
export function formatDate(value) {
  if (!value) return '—'

  const date = new Date(value)

  // Handle invalid dates safely
  if (isNaN(date.getTime())) {
    return value
  }

  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
  }).format(date)
}

/** Truncate string with ellipsis */
export function truncate(str, maxLen = 30) {
  if (!str) return ''
  return str.length > maxLen
    ? str.slice(0, maxLen) + '…'
    : str
}

/** Get user's initials from name */
export function getInitials(name = '') {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('')
}

/** Sleep (useful in dev/mock) */
export const sleep = (ms) =>
  new Promise((r) => setTimeout(r, ms))